export default {
  selectLang: "Select Language",
  footer: {
    copyright: "© 2025 TaxEcoBit. All rights reserved.",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    help: "Support or Suggestions?",
  },
  menu: {
    dashboard: "Dashboard",
    calculate: "Calculate",
    calculations: "Calculations",
    pricing: "Pricing",
    settings: "Settings",
    factors: "Factors",
    reports: "Reports",
    upgrade: "Upgrade",
    usage: "Usage",
    invite: "Invitations",
    home: "Home",
    blog: "Blog",
    whitepaper: "Whitepaper",
    about: "About Us",
    faq: "FAQ",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    tickets: "Tickets",
    billing: "Billing",
    "billing-overview": "Overview",
    "billing-orders": "Orders",
    "billing-invoices": "Invoices",
    "billing-subscription": "Subscription",
    templates: "Templates",
  },
  upgradeWall: {
    successTitle: "Trial Application Successful",
    successSubtitle: "You have successfully applied for 14-day free Pro plan trial",
    quotaTitle: "Calculation Quota:",
    reportQuotaTitle: "Report Quota:",
    planComparison: "Plan Features Comparison",
    calculation: "Calculation",
    report: "Report",
    price: "Price",
    viewPricing: "View Full Pricing",
    freeTrial: "14-Day Free Pro Trial",
    upgradeToPro: "Upgrade to Pro",
    upgradePro: "Upgrade Pro",
    contactSupport: "Contact Support",
    inviteRewards: "Get More Quota Through Invitations!",
    inviteRewardsDesc:
      "Invite friends to register, and both you and your friends will receive additional calculation quotas",
    inviteFriends: "Invite Friends",
    quotaExhausted: "Your Plan Quota Has Been Exhausted",
    calculationThreshold: "Your Calculation Quota Has Been Used {percent}%",
    reportThreshold: "Your Report Quota Has Been Used {percent}%",
    upgradePlan: "Upgrade Your Plan",
    free: "Free",
    basic: "€49/month",
    proPrice: "€99/month",
    timesPerMonth: "times/month",
    plan: "Plan",
    trialSuccess: "Trial application successful",
  },
  ticket: {
    modal_title: "Submit Ticket",
  },
  brand: {
    what_is_taxecobit: "What is TaxEcoBit?",
    taxecobit_description:
      "TaxEcoBit is a compliance automation platform built for businesses affected by the EU Carbon Border Adjustment Mechanism (CBAM). We help importers, manufacturers, and SMEs calculate product-level carbon emissions, generate CBAM-compliant reports, and reduce regulatory risks.",
    taxecobit_benefits: "With TaxEcoBit, users can:",
    benefit_accurate_calculations:
      "Perform accurate carbon calculations using official and custom emission factors",
    benefit_cbam_documents: "Generate submission-ready CBAM documentation",
    benefit_carbon_cost_tracking: "Monitor carbon cost impact and optimize operational efficiency", // 修改：移除审计记录，强调成本优化
    benefit_api_integration:
      "Seamlessly integrate compliance workflows via API with ERP and supply chain systems", // 优化：突出 API 集成流畅性
    taxecobit_conclusion:
      "By replacing manual spreadsheets and consulting dependency, TaxEcoBit enables faster, more reliable compliance at a lower operational cost.",
  },
  userLevel: {
    label: "User Level",
    highest_level: "Highest Level",
    next_level: "Next Level: {level}",
    standard_user: "Standard User",
    bronze_user: "Bronze User",
    silver_user: "Silver User",
    gold_user: "Gold User",
    platinum_user: "Platinum User",
    bronze_next: "Bronze (50 calculations)",
    silver_next: "Silver (150 calculations)",
    gold_next: "Gold (300 calculations)",
    platinum_next: "Platinum (600 calculations)",
    highest_level_text: "Highest level reached",
  },
  notification: {
    title: "Notifications",
    settings: "Notification Settings",
    preferences: "Notification Preferences",
    email_notifications: "Email Notifications",
    app_notifications: "Application Notifications",
    all: "All Notifications",
    important: "Important Notifications Only",
    none: "No Notifications",
    save_preferences: "Save Notification Preferences",
    success_message: "Notification preferences saved successfully",
    error_message: "Failed to save notification preferences",
    detail_title: "Notification Details",
    mark_as_read: "Mark as Read",
    not_found_title: "Notification Not Found",
    not_found_desc: "The notification you are looking for does not exist or has been deleted.",
    search_placeholder: "Search by title or content",
    email_sent: "Email Sent",
    in_app_only: "In-App",
    no_notifications: "No notifications",
    total: "Total {total} notifications",
    fetch_failed: "Failed to fetch notifications",
    marked_as_read: "Marked as read successfully",
    mark_failed: "Failed to mark as read",
    mark_all_read: "Mark All as Read",
    view_all: "View All",
  },
  notFound: {
    title: "404 Not Found",
    description: "Sorry, the page you visited does not exist.",
    goHome: "Back Home",
  },
  login: {
    sign_in: "Sign In",
    sign_up: "Sign Up",
    password_rule_length: "At least 8 characters",
    password_rule_letter: "Contains English letters",
    password_rule_number: "Contains numbers",
    password_rule_special: "Contains special characters {0}",
  },
};
